import { Form, Formik } from "formik";

import { putApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";

import Button from "../../components/common/button/Button";
import Input from "../../components/common/inputs/Input";
import AdminFormLayout, { FormSection } from "../../components/common/form-layout/AdminFormLayout";
import { useLocation, useNavigate } from "react-router";
import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import { citiesListColumns } from "../../constant/tables-columns/tablesColums";

export default function EditCities() {
  const location = useLocation();
  const navigate = useNavigate();

  const [cities, setCities] = useState([]);

  const addCity = async (values, { resetForm }) => {
    const isExist = cities.filter((item) => {
      return item.name == values.name;
    });
    if (!isExist?.length) {
      setCities((prev) => [...prev, { name: values.name, id: values.name }]);
      successMessage(`شهر ${values?.name} اضافه شد.`);
      resetForm()
    } else {
      warningMessage(`شهر ${values?.name} از قبل وجود دارد.`);
    }
  };

  const formHandler = async () => {
    const body = {
      cities: cities.map((item) => {
        return item.name;
      }),
    };
    const path = `admin/provinces/${location?.state?.id}/cities`;
    try {
      const response = await putApi({ path, body: JSON.stringify(body) });
      console.log(response);
      successMessage(`شهر های ${location?.state?.name} با موفقیت ویرایش شدند.`);
      navigate("/province-list");
    } catch (error) {
      console.error(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  useEffect(() => {
    if (location?.state?.cities?.length) {
      setCities(
        location?.state?.cities.map((item) => {
          return {
            name: item,
            id: item,
          };
        })
      );
    }
  }, [location?.state]);

  const delteCity = (data) => {
    const newCities = cities.filter((item) => {
      return item.name != data.name;
    });
    setCities(newCities);
  };

  return (
    <AdminFormLayout title={`ویرایش شهرهای استان ${location?.state?.name}`} description="شهرهای استان را اضافه یا حذف کنید و در پایان تغییرات را ذخیره کنید.">

      <Formik
        enableReinitialize
        initialValues={{
          name: "",
        }}
        onSubmit={addCity}
      >
        {(formik) => (
          <Form>
            <div className="mt-6">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <Input
                  name={"name"}
                  placeholder={"نام"}
                  label={"نام"}
                  type="text"
                />
              </div>

              <div className="flex flex-col gap-y-2">
                <div className="admin-form-actions">
                  <Button disabled={formik.isSubmitting} loading={formik.isSubmitting} type="submit" text={"افزودن"} color={"success"} />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>

      <FormSection title="شهرهای استان" description="حذف و افزودن شهرها پس از ذخیره تغییرات ثبت می‌شود.">
        <Table columns={citiesListColumns} rows={cities} onDelete={delteCity} />
      </FormSection>

      <div className="flex flex-col gap-y-2">
        <div className="admin-form-actions">
          <Button
            text={"ذخیره تغییرات شهرها"}
            type="button"
            color={"success"}
            onClick={formHandler}
          />
          <button type="button" className="admin-form-cancel" onClick={() => navigate("/province-list")}>انصراف</button>
        </div>
      </div>
    </AdminFormLayout>
  );
}
